import { TranslateService } from '@ngx-translate/core';
import { IValidationConstraint, ValidationKeys } from '../models';

export class ValidationMessagesProviderService {
	public constructor(private translate: TranslateService) {}

	public getCustomValidationMessage(
		validationType: string,
		constraint?: IValidationConstraint,
		isColumnNumeric?: boolean
	): Record<string, string> {
		switch (validationType) {
			case ValidationKeys.validationTypes.noSpecialCharacter:
				return {
					type: ValidationKeys.validationTypes.noSpecialCharacter,
					message: this.translate.instant('formValidations.noSpecialCharacter')
				};
			case ValidationKeys.validationTypes.whitespacesOnlyInTheMiddle:
				return {
					type: ValidationKeys.validationTypes.whitespacesOnlyInTheMiddle,
					message: this.translate.instant('formValidations.whitespacesOnlyInTheMiddle')
				};
			case ValidationKeys.validationTypes.lessThan:
				return {
					type: ValidationKeys.validationTypes.lessThan,
					message: this.translate.instant('formValidations.lessThan')
				};
			case ValidationKeys.validationTypes.greaterThan:
				return {
					type: ValidationKeys.validationTypes.greaterThan,
					message: this.translate.instant('formValidations.greaterThan')
				};
			case ValidationKeys.validationTypes.startDate:
				return {
					type: ValidationKeys.validationTypes.startDate,
					message: this.translate.instant('formValidations.startDate')
				};
			case ValidationKeys.validationTypes.completedDate:
				return {
					type: ValidationKeys.validationTypes.completedDate,
					message: this.translate.instant('formValidations.completedDate')
				};
			case ValidationKeys.validationTypes.required:
				return {
					type: ValidationKeys.validationTypes.required,
					message: this.translate.instant('formValidations.required')
				};
			case ValidationKeys.validationTypes.minimumValue:
				return {
					type: ValidationKeys.validationTypes.minimumValue,
					message: this.translate.instant('formValidations.minVal') + `${constraint}.`
				};
			case ValidationKeys.validationTypes.maximumValue:
				return {
					type: ValidationKeys.validationTypes.maximumValue,
					message: this.translate.instant('formValidations.maxVal') + `${constraint}.`
				};
			case ValidationKeys.validationTypes.decimalPlaces:
				return {
					type: ValidationKeys.validationTypes.decimalPlaces,
					message:
						!Number.isNaN(constraint) && Number(constraint) > 0
							? this.translate.instant('formValidations.decimalPlaces.only') +
							  `${constraint}` +
							  this.translate.instant('formValidations.decimalPlaces.areAllowed')
							: this.translate.instant('formValidations.decimalPlaces.noDecimal')
				};
			case ValidationKeys.validationTypes.maximumLength:
				return {
					type: ValidationKeys.validationTypes.maximumLength,
					message:
						this.translate.instant('formValidations.maximumLength.maxLengthOf') +
						`${constraint}` +
						(isColumnNumeric
							? this.translate.instant('formValidations.maximumLength.digitsReached')
							: this.translate.instant('formValidations.maximumLength.charactersReached'))
				};
			case ValidationKeys.validationRules.intervalBreachRule:
				return {
					type: ValidationKeys.validationRules.intervalBreachRule,
					message: this.translate.instant('formValidations.intervalBreach')
				};
			case ValidationKeys.validationRules.intervalOverlapRule:
				return {
					type: ValidationKeys.validationRules.intervalOverlapRule,
					message: this.translate.instant('formValidations.intervalOverlap')
				};
			case ValidationKeys.validationRules.intervalDupRule:
				return {
					type: ValidationKeys.validationRules.intervalDupRule,
					message: this.translate.instant('formValidations.intervalDuplicate')
				};
			case ValidationKeys.validationRules.intervalGapRule:
				return {
					type: ValidationKeys.validationRules.intervalGapRule,
					message: this.translate.instant('formValidations.intervalGaps')
				};
			case ValidationKeys.validationRules.preventIntervalCorruptionRule:
				return {
					type: ValidationKeys.validationRules.preventIntervalCorruptionRule,
					message: this.translate.instant('formValidations.preventIntervalCorruption')
				};
			case ValidationKeys.validationRules.startAtZeroRule:
				return {
					type: ValidationKeys.validationRules.startAtZeroRule,
					message: this.translate.instant('formValidations.startAtZero')
				};
			case ValidationKeys.validationRules.uniquePrimaryKeyRule:
				return {
					type: ValidationKeys.validationRules.uniquePrimaryKeyRule,
					message: this.translate.instant('formValidations.uniquePrimaryKey')
				};
			case ValidationKeys.validationRules.uniqueComposedPrimaryKeyRule:
				return {
					type: ValidationKeys.validationRules.uniqueComposedPrimaryKeyRule,
					message: this.translate.instant('formValidations.uniqueComposedPrimaryKey')
				};
			case ValidationKeys.validationRules.uniqueDeletedPrimaryKeyRule:
				return {
					type: ValidationKeys.validationRules.uniqueDeletedPrimaryKeyRule,
					message: this.translate.instant('formValidations.uniqueDeletedPrimaryKey')
				};
			case ValidationKeys.validationRules.uniqueDeletedComposedPrimaryKeyRule:
				return {
					type: ValidationKeys.validationRules.uniqueDeletedComposedPrimaryKeyRule,
					message: this.translate.instant('formValidations.uniqueDeletedComposedPrimaryKey')
				};
			case ValidationKeys.validationRules.uniqueSampleNumberRule:
				return {
					type: ValidationKeys.validationRules.uniqueSampleNumberRule,
					message: this.translate.instant('formValidations.uniqueSampleNumber')
				};
			case ValidationKeys.validationRules.uniqueDeletedSampleNumberRule:
				return {
					type: ValidationKeys.validationRules.uniqueDeletedSampleNumberRule,
					message: this.translate.instant('formValidations.uniqueDeletedSampleNumber')
				};
			case ValidationKeys.validationRules.uniqueStandardNumberRule:
				return {
					type: ValidationKeys.validationRules.uniqueStandardNumberRule,
					message: this.translate.instant('formValidations.uniqueStandardNumber')
				};
			case ValidationKeys.validationRules.uniqueDeletedStandardNumberRule:
				return {
					type: ValidationKeys.validationRules.uniqueDeletedStandardNumberRule,
					message: this.translate.instant('formValidations.uniqueDeletedStandardNumber')
				};
			case ValidationKeys.validationRules.notSupportedCharactersRule:
				return {
					type: ValidationKeys.validationRules.notSupportedCharactersRule,
					message: this.translate.instant('formValidations.notSupportedCharacters')
				};
		}
	}
}
